import { render } from "./PasswordRequest.vue?vue&type=template&id=50f9ac5e&scoped=true&ts=true"
import script from "./PasswordRequest.vue?vue&type=script&lang=ts"
export * from "./PasswordRequest.vue?vue&type=script&lang=ts"

import "./PasswordRequest.vue?vue&type=style&index=0&id=50f9ac5e&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f9ac5e"]])

export default __exports__